(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9396],{

/***/ 94217:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacy-policy",
      function () {
        return __webpack_require__(31607);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 31607:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ privacy_policy; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./blocks/Layouts/page-layout/index.ts + 4 modules
var page_layout = __webpack_require__(80264);
// EXTERNAL MODULE: ./blocks/Layouts/GlobalLayout.tsx + 3 modules
var GlobalLayout = __webpack_require__(94082);
;// CONCATENATED MODULE: ./assets/privacy-policy/header-image.webp
/* harmony default export */ var header_image = ({"src":"/_next/static/media/header-image.e94f99cc.webp","height":1000,"width":1780,"blurDataURL":"data:image/webp;base64,UklGRkoAAABXRUJQVlA4ID4AAACwAQCdASoIAAQAAkA4JQBOgB6Qo6DAAP70uFDId605gK4yBYmafmIrCSdFxkN0X+BWhfkf+qvW40p4dwAAAA==","blurWidth":8,"blurHeight":4});
// EXTERNAL MODULE: ./components/accordion-list/index.ts + 5 modules
var accordion_list = __webpack_require__(98736);
;// CONCATENATED MODULE: ./blocks/privacy-policy-item/PrivacyPolicyItem.tsx

var PrivacyPolicyItem = function(param) {
    var privacyPolicies = param.privacyPolicies;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: privacyPolicies.map(function(listItem, index) {
            var ref;
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                className: "privacy-policy-list_item",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "privacy-policy-list_description",
                        children: listItem.description
                    }),
                    listItem && /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
                        children: listItem === null || listItem === void 0 ? void 0 : (ref = listItem.innerList) === null || ref === void 0 ? void 0 : ref.map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: item.description
                            }, index.toString());
                        })
                    })
                ]
            }, index.toString());
        })
    });
};
/* harmony default export */ var privacy_policy_item_PrivacyPolicyItem = (PrivacyPolicyItem);

;// CONCATENATED MODULE: ./blocks/privacy-policy-item/index.ts


;// CONCATENATED MODULE: ./pages/privacy-policy.tsx








var PrivacyPolicy = function(param) {
    var globalLayoutProps = param.globalLayoutProps, privacyPolicies = param.privacyPolicies, pageContent = param.pageContent;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalLayout/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, globalLayoutProps), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(page_layout/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, pageContent), {
            image: header_image,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "privacy-policy-page",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(accordion_list/* default */.Z, {
                    items: privacyPolicies,
                    getId: function(item) {
                        return item.title;
                    },
                    getTitle: function(item) {
                        return item.title;
                    },
                    getContent: function(item) {
                        return [
                            item
                        ];
                    },
                    renderContent: function(item) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(privacy_policy_item_PrivacyPolicyItem, {
                            privacyPolicies: item.list
                        });
                    }
                })
            })
        }))
    }));
};
var __N_SSG = true;
/* harmony default export */ var privacy_policy = (PrivacyPolicy);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7295,5675,5156,4520,4713,9774,2888,179], function() { return __webpack_exec__(94217); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);